import React from 'react';
import { Icon } from 'semantic-ui-react';

const indicatorConfig = {
    workDay: { icon: 'briefcase', title: 'Work day' },
    financialNote: { icon: 'sticky note outline', title: 'Financial note' },
    scheduledDay: { icon: 'calendar alternate outline', title: 'Scheduled day' },
    tedDay: { icon: 'dollar sign', title: 'TED day (hybrid contract)' }
};

const PayDetailDateCell = ({ row = {}, date = '' }) => {
    const safeRow = row || {};
    const indicatorKeys = Array.isArray(safeRow.indicatorKeys)
        ? safeRow.indicatorKeys.filter(key => typeof key === 'string' && indicatorConfig[key])
        : [];
    const displayDate = date || safeRow.date || safeRow.dateKey || '';

    return (
        <span className="pay-detail-date-cell">
            <span>{displayDate}</span>
            {indicatorKeys.map((key) => {
                const indicator = indicatorConfig[key];

                return (
                    <Icon
                        key={key}
                        name={indicator.icon}
                        title={indicator.title}
                        aria-label={indicator.title}
                        className="pay-detail-date-icon"
                    />
                );
            })}
        </span>
    );
};

export default PayDetailDateCell;
